import componentsInit from 'components';
import dataInit from 'data';
import ecommerceInit from 'ecommerce';
import editorInit from 'editor/init';
import i18n from 'internationalization';

import packageInfo from '../../../package.json';

import images from './specifications/images.json';
import i18nProducts from './specifications/i18n/products.json';

i18n.addResourceBundle('en', 'products', i18nProducts);

const SETTINGS = {
  APP_NAME: process.env.APP_NAME,
  APP_COPY: process.env.APP_COPY,
  DEBUG: false,
  BUILD_ID: process.env.BUILD_ID,
  HOST: process.env.HOST,
  API_HOST: process.env.API_HOST,
  TEMPLATE_HOST: process.env.TEMPLATE_HOST,
  API_GATEWAY_HOST: process.env.API_GATEWAY_HOST,
  CLIENT_ID: process.env.CLIENT_ID,
  VERSION: packageInfo.version,
  USER_AGENT: process.env.USER_AGENT,
  COOKIE_ACCESS_TOKEN_NAME: process.env.COOKIE_ACCESS_TOKEN_NAME,
  COOKIE_ACCESS_TOKEN_OPTIONS: {
    // TODO https://github.com/maticzav/nookies#setcookiectx-name-value-options-or-cookiessetctx-name-value-options
    maxAge: 30 * 24 * 60 * 60,
    path: '/',
  },
  COOKIE_COUNTRY_CODE_NAME: 'parabo.country.code',
  COOKIE_COUNTRY_CODE_OPTIONS: {
    // TODO https://github.com/maticzav/nookies#setcookiectx-name-value-options-or-cookiessetctx-name-value-options
    maxAge: 365 * 24 * 60 * 60,
    path: '/',
  },
  COOKIE_ALLOW_COOKIES_NAME: 'parabo.allow.cookies',
  COOKIE_ALLOW_COOKIES_OPTIONS: {
    // TODO https://github.com/maticzav/nookies#setcookiectx-name-value-options-or-cookiessetctx-name-value-options
    maxAge: 365 * 24 * 60 * 60,
    path: '/',
  },
  CLOUDINARY_ROOT_URL: process.env.CLOUDINARY_ROOT_URL,
  DEFAULT_COUNTRY_CODE: 'US',
  STRIPE_API_KEY: process.env.STRIPE_API_KEY,
  FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
  AMAZON_PAY_SELLER_ID: process.env.AMAZON_PAY_SELLER_ID,
  AMAZON_PAY_V2_STORE_ID: process.env.AMAZON_PAY_V2_STORE_ID,
  AMAZON_PAY_V2_PUBLIC_KEY_ID: process.env.AMAZON_PAY_V2_PUBLIC_KEY_ID,
  UPPY_HOST: process.env.UPPY_HOST,
  UPPY_SOURCES: ["qr"], // TODO temp removed 'instagram'
  UPPY_ALLOWED_HOST: process.env.UPPY_ALLOWED_HOST,
  FILESTACK_API_KEY: process.env.FILESTACK_API_KEY,
  FILESTACK_DISABLED: false,
  IMAGIFER_URL: process.env.IMAGIFER_URL,
  REDIS_URL: process.env.REDIS_URL,
  INSTAGRAM_APP_ID: '976768666097473',
  INSTAGRAM_REDIRECT_URI: `${process.env.HOST}/connect/instagram`,
  X_URL: 'https://x.com/parabopress',
  FACEBOOK_URL: 'https://www.facebook.com/parabopress/',
  INSTAGRAM_URL: 'https://www.instagram.com/parabopress/',
  PINTEREST_URL: 'https://www.pinterest.com/parabopress/',
  APP_STORE_ID: '738433203',
  APP_STORE_URL: 'https://apps.apple.com/us/app/parabo-press/id738433203',
  // Custom product page with photo book screenshots, used on /photo-books.
  PHOTO_BOOKS_APP_STORE_URL:
    'https://apps.apple.com/us/app/parabo-press-photo-prints/id738433203?ppid=dd7c5ded-7e26-4b91-bd52-149fb639c78c',
  POLOTNO_API_KEY: process.env.POLOTNO_API_KEY,
  POLOTNO_REMOTE_PDFER_URL: process.env.POLOTNO_REMOTE_PDFER_URL,
  GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
  GEDCOM_API_URL: process.env.GEDCOM_API_URL,
  DRAFTS_WSS_URL: process.env.DRAFTS_WSS_URL,
  SCRIPTS: {
    ROLLBAR_CLIENT_ACCESS_TOKEN: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,
    ROLLBAR_ENV: process.env.ROLLBAR_ENV,
    FACEBOOK_PIXEL_ID: process.env.FACEBOOK_PIXEL_ID,
    PINTERESET_PIXEL_ID: '2616990219829',
    SHAREASALE_ID: '94670778e4',
    GTAG_ID: process.env.GTAG_ID,
    ATTENTIVE_ID: 'parabopress',
    GROOVE_ID: '6c7816c7-867b-460b-a6ec-cda24e0915a1',
    OMNISEND_ID: '607dbac18a48f707858392a5',
    LOGDNA_INGESTION_KEY: '34612c2a9c9c9b00710c0a4f05a264ba',
    COMMIT_HASH: process.env.COMMIT_HASH,
    POSTHOG_KEY: process.env.POSTHOG_KEY,
    POSTHOG_HOST: process.env.POSTHOG_HOST,
  },
  EDITOR_WHITE_LABELED_DOMAINS: [
    /(?:http|https)\S+parabo\S+amazonaws.com(?:\s|\S)+/,
    /(?:http|https)\S+amazonaws.com\S+parabo(?:\s|\S)+/,
    /(?:http|https)\S+photolane\S+amazonaws.com(?:\s|\S)+/,
    /(?:http|https)\S+amazonaws.com\S+photolane(?:\s|\S)+/,
  ],
  NEWSLETTER_URL:
    'https://omniform1.com/signup/v1/607dbac18a48f707858392a5_60b7f23899f0b7121fafc713.html',
};

export const updateSettings = (override = {}) => {
  Object.entries(override).forEach(([key, value]) => {
    SETTINGS[key] = value;
  });

  componentsInit(SETTINGS, images);
  ecommerceInit(SETTINGS);
  dataInit(SETTINGS);
  editorInit(SETTINGS);
};

updateSettings();

export default SETTINGS;
